import { render } from "./SecretQuestion.vue?vue&type=template&id=1c5d8597&scoped=true&ts=true"
import script from "./SecretQuestion.vue?vue&type=script&lang=ts"
export * from "./SecretQuestion.vue?vue&type=script&lang=ts"

import "./SecretQuestion.vue?vue&type=style&index=0&id=1c5d8597&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c5d8597"]])

export default __exports__